import { IBriefProduct } from "../../../../types/product/ibrief-product/ibrief-product.interface";
import { BuyGetStatus } from "../../../../types/product/ibrief-product/buy-get-status.enum";

import { BriefProductForm, BriefProductsForm } from "./brief-product-form.interface";

export function createBriefProductForm(product?: IBriefProduct): BriefProductForm {
  if (!product) {
    return createEmptyBriefProductForm();
  }

  return {
    id: product.id,
    positionText: product.positionDescription || "",
    relatedGetProductIds: getRelatedGetProducts(product),
    futurePrice: typeof product.futurePrice === "number" ? product.futurePrice.toFixed(2) : "",
    buyGetStatus: getBuyGetStatus(product),
  };
}

function createEmptyBriefProductForm(): BriefProductForm {
  return {
    id: 0,
    positionText: "",
    relatedGetProductIds: [],
    futurePrice: "",
    buyGetStatus: BuyGetStatus.Neither,
  };
}

function getBuyGetStatus(product?: IBriefProduct): BuyGetStatus {
  if (product?.buyGetStatus === undefined) {
    return BuyGetStatus.Neither;
  }

  return product.buyGetStatus;
}

function getRelatedGetProducts(product?: IBriefProduct): number[] {
  if (product?.buyGetStatus !== BuyGetStatus.Buy) {
    return [];
  }

  return product.relatedGetProducts ?? [];
}

export const mapProductsToForm = (products: IBriefProduct[]): BriefProductsForm => {
  const list = products.map(createBriefProductForm);

  return { products: list };
};
